import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { PartnerConfigurationsViewAccessControl } from '../access-control/partnerConfigurationsAdminAccess.configuration'

const PartnerConfigurationsListPage = lazy(
  () => import('../pages/list/PartnerConfigurationsListPage')
)

const PartnerConfigurationTypesListPage = lazy(
  () => import('../pages/list/PartnerConfigurationTypesListPage')
)

// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const partnerConfigurationsAdminRouter = (
  <DomainRoute route="app-admin-partner-configurations">
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-partner-configurations-list"
        component={PartnerConfigurationsListPage}
        accessControl={PartnerConfigurationsViewAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-partner-configuration-types-list"
        component={PartnerConfigurationTypesListPage}
        accessControl={PartnerConfigurationsViewAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
